import {
  KeyboardArrowDown as KeyboardArrowDownIcon,
  KeyboardArrowUp as KeyboardArrowUpIcon,
} from '@mui/icons-material';
import {
  Box,
  IconButton,
  styled,
  TableCell,
  TableContainer,
  TableHead,
} from '@mui/material';

import { SORT_DIRECTION } from './ListLocationTagsPage.interface';

export const CustomTableContainer = styled(TableContainer)`
  width: 100%;
  height: calc(100vh - 90px);
  overflow: auto;
`;

export const ContentContainer = styled(Box)`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  flex: 3.25; // Value set to match design spec
  overflow: hidden;
`;

export const TableCellContent = styled(TableCell)`
  text-align: left;
  size: small;
  white-space: pre-wrap;
`;
export const CustomTableHead = styled(TableHead)(
  ({ theme }) => `
    th {
    border-bottom: 2px solid ${theme.palette.brand.black};
      font-weight : 700;
      font-size: 1rem;
    },
    thead {
      border-bottom: 2px solid ${theme.palette.brand.black};
    }
  `,
);

export const CustomTableCell = styled(TableCell)<{ isdoublewidth: string }>`
  width: ${(props: { isdoublewidth: string }) =>
    props.isdoublewidth === 'tag' ? '65vw;' : '20vw'};
  font-size: 16px;
`;

export const TableHeadCell = styled(Box)`
  display: flex;
  border: none;
  justify-content: space-between;
  align-items: center;
`;

export const ArrowIcon = styled(Box)`
  height: 12px;
  cursor: pointer;
`;

export const KeyboardArrowUpIconStyled = styled(KeyboardArrowUpIcon)`
  color: ${(props: {
    $selectedColumn: boolean;
    $sortDirection: SORT_DIRECTION;
    theme: { palette: { primary: { main: string } } };
  }) =>
    props.$selectedColumn && props.$sortDirection === SORT_DIRECTION.ASC
      ? props.theme.palette.primary.main
      : 'inherit'};
  font-size: large;
`;

export const KeyboardArrowDownIconStyled = styled(KeyboardArrowDownIcon)`
  color: ${(props: {
    $selectedColumn: boolean;
    $sortDirection: SORT_DIRECTION;
    theme: { palette: { primary: { main: string } } };
  }) =>
    props.$selectedColumn && props.$sortDirection === SORT_DIRECTION.DESC
      ? props.theme.palette.primary.main
      : 'inherit'};
  font-size: large;
`;

export const SortIcons = styled(Box)`
  width: 14px;
  height: 31px;
  display: flex;
  flex-direction: column;
`;
export const TableCellActions = styled(TableCell)`
  text-align: right;
  size: small;
`;

export const IconWrapper = styled(IconButton)(
  ({ theme }) => `
    &:hover svg {
      fill: ${theme.palette.primary.main};
    }
  `,
);
